import React from "react";

interface MailForwardProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  className?: string;
}

export const MailForward = ({
  size = 32,
  className,
  ...props
}: MailForwardProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <g clipPath="url(#clip0_4147_17039)">
      <path
        d="M16 23.9999H6.66667C5.95942 23.9999 5.28115 23.719 4.78105 23.2189C4.28095 22.7188 4 22.0405 4 21.3333V7.99992C4 7.29267 4.28095 6.6144 4.78105 6.1143C5.28115 5.6142 5.95942 5.33325 6.66667 5.33325H25.3333C26.0406 5.33325 26.7189 5.6142 27.219 6.1143C27.719 6.6144 28 7.29267 28 7.99992V17.9999"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 8L16 16L28 8"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 24H28"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 20L28 24L24 28"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4147_17039">
        <rect width={32} height={32} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
